const styles = {
  labelIdent: {
    textAlign: "right",
    color:'gray',
    marginTop:'15px',
    fontWeight:'400',
    "@media (max-width: 600px)": {
      textAlign: "left",
      marginTop:'0px',
    },
  },
  containerin:{
    width:'100%'
  }   
};

export default styles;